import { render, staticRenderFns } from "./LgFinderPageTipoVigencia.vue?vue&type=template&id=b8c54a12"
import script from "./LgFinderPageTipoVigencia.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoVigencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports